module.exports = __webpack_public_path__ + "static/media/cloud-upload-alt.cfb31bfe.svg";